<template>
  <div>
    <van-nav-bar class="bg-gradual-blue" title="座位预约" left-text="返回" @click-left="goback();" left-arrow />
    <van-list>
      <van-cell @click="NextStep(item.roomId)" v-for="item in roomList" :key="item.roomId" :title="item.roomName+' 空余：'+item.freeCount" is-link />
    </van-list>
  </div>
</template>

<script>
import { loadData } from '@/utils/common'

export default {
  props: {
    rdata: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      roomList:[]
    }
  },
  mounted() {
    this.onLoad();
  },
  beforeDestroy() {

  },
  methods: {
    onLoad() {
      // 异步更新数据
      let _this = this;
      let paramsJson = {
        "dateStr": _this.rdata.orderDate,
        "libraryId": _this.rdata.libId,
        "startTime": _this.rdata.startHourStr,
        "endTime": _this.rdata.endIndex
      };
      loadData('/appSeat/queryRoomList',paramsJson).then(response => {
        if(response && response.code == 0){
          this.roomList = response.data;
        }
      }).catch(() => {

      })
    },
    NextStep(id){
      this.$emit("notice",  {'page':'room','roomid':id})
    },
    goback(){
      this.$emit("notice",  {'page':'room','isback':'1'})
    }
  }
}
</script>
